const isLoadingVisible = ({ uiState }) => uiState.loading.isVisible;

const isModalVisible = ({ uiState }) => !uiState.loading.isVisible && uiState.modal.isVisible;

const getCurrentTarget = ({ uiState }) => uiState.modal.currentTarget;

const getSnackbarState = ({ uiState }) => uiState.snackbar;

const isLoadingPage = ({ uiState }) => uiState.loadingPage.isLoading;

export { isLoadingVisible, isModalVisible, getSnackbarState, getCurrentTarget, isLoadingPage };
